var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4.5,
    x: 5,
    y: 23.5,
    fill: "#647A97",
    fillRule: "nonzero",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#647A97",
    fillRule: "nonzero",
    d: "M9.5 18.5H5.834a1 1 0 00-.924.615l-.833 2A1.001 1.001 0 005 22.5h4.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM27.5 4h-7a.5.5 0 00-.5.5v23a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-23a.5.5 0 00-.5-.5zm-4.25 17.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0V7a.75.75 0 011.5 0v1zm3 13.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0V7a.75.75 0 011.5 0v1zm-10.896 6.146a.5.5 0 00-.707 0l-3.5 3.5A.5.5 0 0011 18v9.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V18a.5.5 0 00-.146-.354l-3.5-3.5zM14.25 25a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm3 4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1zm0-4.5a.75.75 0 01-1.5 0v-1a.75.75 0 011.5 0v1z"
  }))));
}
export default SvgBuilding;